import Header from '@/components/Header'
import useDocumentTitle from '@/components/Helmet';
import PropertyCard from '@/components/PropertyCard';
import { useToast } from '@/hooks/use-toast';
import axiosInstance from '@/lib/axiosInstance';
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const Favorites = () => {
    useDocumentTitle("Favorites");
    const { toast } = useToast();
    const user  = useSelector((state: any) => state.auth.user);
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [favorites, setFavorites] = useState<any>([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);

    const fetchFavorites = useCallback(async () => {
        try {
            await axiosInstance.get(`/api/favorites?limit=${limit}&page=${page + 1}`).then((res) => {
                setFavorites(res.data.data);
                setCount(res.data.count);
            })
        } catch (error: any) {
            toast({
                variant: "destructive",
                title: "Error!",
                description: error?.response?.data?.message || "Something went wrong",
            })
        }
    }, [page, limit])

    useEffect(() => {
        fetchFavorites();
    }, [fetchFavorites])
    return (
        <div>
            <Header />
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <h2 className="text-2xl font-semibold mb-4">Favorites</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {favorites.map((property : any) => (
                        <PropertyCard
                            key={property._id}
                            property={property?.property}
                            showFavoriteButton={!!user}
                        />
                    ))}
                </div>
            </section>
        </div>
    )
}

export default Favorites